import React from 'react';
import css from './index.module.scss';
import { IActivity } from '@helpers/types/activity';
import { Image, Typography } from '@components/base';
import { getFormattedDate, getFormattedTime } from '@helpers/utils';
import { ListPlaceholder } from '..';
import OrderProgressSkeleton from './skeleton';

interface ActivityTabProps {
  activityList: IActivity[];
  isLoading: boolean;
  emptyStateConfig: {
    title: string;
    supportingText: string;
    buttonText: string;
    to: string;
  };
  defaultUserName: string;
}

const ActivityTab: React.FC<ActivityTabProps> = ({
  activityList,
  isLoading,
  emptyStateConfig = {
    title: 'No Activity performed on this order yet',
    supportingText: 'When any activity is performed on this order, it will show up here.',
    buttonText: '',
    to: ''
  },
  defaultUserName = 'Elchemy Internal Member'
}) => {
  return (
    <>
      {activityList.length === 0 && !isLoading ? (
        <ListPlaceholder
          to={emptyStateConfig.to}
          title={emptyStateConfig.title}
          supportingText={emptyStateConfig.supportingText}
          buttonText={emptyStateConfig.buttonText}
        />
      ) : (
        <>
          <section className={css.wrapper}>
            <div className={css.mainWrapper}>
              {activityList?.map((activity: IActivity) => (
                <div key={activity?.timestamp} className={css.cardWrapper}>
                  <div className={css.card}>
                    <div>
                      <div className={css.cardTitle}>
                        <Typography variant="h5">{activity?.activity_log}</Typography>
                      </div>
                      <Typography variant="label" className={css.cardContent}>
                        {getFormattedDate(activity?.timestamp)} at{' '}
                        {getFormattedTime(activity?.timestamp)} by{' '}
                        <Typography variant="label" className={css.userName}>
                          {activity?.full_name ?? defaultUserName}
                        </Typography>
                      </Typography>
                    </div>

                    <Image
                      src={activity?.profile_image ?? ''}
                      alt={`${activity?.full_name ?? defaultUserName} icon`}
                      className={css.profileIcon}
                      fallbackText={`${
                        activity?.full_name?.toLocaleUpperCase() ?? defaultUserName
                      }`}
                    />
                  </div>
                </div>
              ))}
            </div>
          </section>
        </>
      )}

      {isLoading && <OrderProgressSkeleton />}
    </>
  );
};

export default ActivityTab;
